"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMRAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const Urls_1 = require("../Urls");
class EMRAdapter {
    constructor(httpAdapter, baseUrl, env) {
        this.httpAdapter = httpAdapter;
        this.baseUrl = baseUrl;
        this.env = env;
    }
    fetchInsuranceDetails(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const targetUrl = `${this.baseUrl}${Urls_1.urls.getInsuranceInformation(mrn)}`;
                const response = yield this.httpAdapter.get(targetUrl, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    fetchPatientDetails(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const targetUrl = `${this.baseUrl}${Urls_1.urls.getPatientInformation(mrn)}`;
                const response = yield this.httpAdapter.get(targetUrl, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                if (e &&
                    typeof e === "object" &&
                    "response" in e &&
                    ((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    return (0, domain_1.CompletedResult)(null);
                }
                throw e;
            }
        });
    }
    fetchRecentMRNs(limit, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Recent MRNs is env-specific: prod uses the query form, qa/local a `/qa` sub-path.
                const patientsUrl = this.baseUrl.replace(/\/$/, "");
                const targetUrl = this.env === "production"
                    ? `${patientsUrl}${Urls_1.urls.getRecentMRNs(limit)}`
                    : `${patientsUrl}/${Urls_1.urls.getRecentMRNsQa(limit)}`;
                const response = yield this.httpAdapter.get(targetUrl, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    fetchPhysicianDetails(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const targetUrl = `${this.baseUrl}${Urls_1.urls.getPhysicianInformation(mrn)}`;
                const response = yield this.httpAdapter.get(targetUrl, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    fetchDiagnosisDetails(mrn, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const targetUrl = `${this.baseUrl}${Urls_1.urls.getDiagnosisInformation(mrn)}`;
                const response = yield this.httpAdapter.get(targetUrl, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
}
exports.EMRAdapter = EMRAdapter;
